// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseRescheduleModalUnscheduleStage_root__RlBWS","button":"CoursePauseRescheduleModalUnscheduleStage_button__ehFgg"};